import styled from "styled-components";
import { space } from "styled-system";
import { RadioProps, scales } from "./types";

const getScale = ({ scale }: RadioProps) => {
  switch (scale) {
    case scales.SM:
      return "12px";
    case scales.MD:
    default:
      return "16px";
  }
};

const getCheckedScale = ({ scale }: RadioProps) => {
  switch (scale) {
    case scales.SM:
      return "6px";
    case scales.MD:
    default:
      return "10px";
  }
};

const Radio = styled.input.attrs({ type: "radio" })<RadioProps>`
  appearance: none;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  display: inline-block;
  height: ${getScale};
  width: ${getScale};
  vertical-align: middle;
  transition: background-color 0.2s ease-in-out;
  border: ${({ theme }) => (theme.isDark ? `solid 2px rgba(255, 255, 255, 0.25)` : "0")};
  border-radius: 50%;
  /* background-color: ${({ theme }) => theme.colors.cardBorder};
  box-shadow: ${({ theme }) => theme.shadows.inset}; */

  &:after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 8px;
    height: 8px;
    border: 1px solid rgb(23, 20, 20);
    border-radius: 50%;
  }

  &:hover:not(:disabled):not(:checked) {
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  &:focus {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  &:checked {
    border: 0;
    // background-color: ${({ theme }) => theme.colors.success};
    background: linear-gradient(93.23deg, #fd8259 0%, #f04340 100%);
    /* &:after {
      // background-color: ${({ theme }) => theme.radio.handleBackground};
      background: linear-gradient(93.23deg, #fd8259 0%, #f04340 100%);
      border: 1px solid ${({ theme }) => theme.colors.background};
    } */
  }

  &:disabled {
    border: 0;
    cursor: default;
    opacity: 0.6;
  }
  ${space}
`;

Radio.defaultProps = {
  scale: scales.MD,
  m: 0,
};

export default Radio;
